import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";

import { EntryType } from "src/library/types/types";

type TeamRadioProps = {
  entryType: number;
  handleRadioChange: Function;
  style?: Object;
};
export default function TeamRadio(props: TeamRadioProps) {
  const { entryType, handleRadioChange, style } = props;

  return (
    <FormControl sx={{ display: "flex", justifyContent: "flex-start" }}>
      <FormLabel id="entry-type-label">
        <Typography
          variant="body1"
          fontWeight="fontWeightBold"
          textAlign="left"
          color="secondary.light"
        >
          Are you wishing to enter as:
        </Typography>
      </FormLabel>
      <RadioGroup aria-labelledby="entry-type-selection" name="entryType" sx={{ pl: 2 }}>
        <FormControlLabel
          label="Team"
          control={
            <Radio
              required
              checked={entryType === EntryType.Team}
              onClick={() => handleRadioChange("entryType", EntryType.Team)}
              sx={style}
            />
          }
        />
        <FormControlLabel
          label="Individual"
          control={
            <Radio
              required
              checked={entryType === EntryType.Individual}
              onClick={() => handleRadioChange("entryType", EntryType.Individual)}
              sx={style}
            />
          }
        />
      </RadioGroup>
    </FormControl>
  );
}
